import { CardContainer, CardKey, CardValue } from '../../StyledComponents/Card';
import CondorSpinner from '../CondorSpinner';
import { IconButton } from '@mui/material';
import { Download } from '@mui/icons-material';
import { useGetDeviceTagsQuery } from '../../gql/generated';

interface CondorStandardTagsProps {
  purpleTag: {
    tagId: string;
    tagName: string;
  };
  yellowTag: {
    tagId: string;
    tagName: string;
  };
}

export const CondorStandardTags = (props: CondorStandardTagsProps) => {
  const { purpleTag, yellowTag } = props;

  const { data: purpleData, loading: purpleLoading } = useGetDeviceTagsQuery({
    variables: {
      input: {
        tagId: purpleTag.tagId,
      },
    },
    skip: !purpleTag.tagId,
  });

  const { data: yellowData, loading: yellowLoading } = useGetDeviceTagsQuery({
    variables: {
      input: {
        tagId: yellowTag.tagId,
      },
    },
    skip: !yellowTag.tagId,
  });

  const handleDownload = (
    tag: { tagId: string; tagName: string },
    data: any,
  ) => {
    const serialNumbers = data?.getDeviceTags?.results
      ?.map((dt: any) => dt?.serialNumber)
      .filter((sn: any): sn is string => !!sn);

    if (!serialNumbers || serialNumbers.length === 0) {
      console.error('No serial numbers found for tagId: ' + tag.tagId);
      return;
    }

    const csvContent = ['Serial Number', ...serialNumbers].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', `${tag.tagName}-serial-numbers.csv`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const loading = purpleLoading || yellowLoading;

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flexBasis: '20%' }}></div>
      <div style={{ flexBasis: '60%' }}>
        <CardContainer>
          {loading ? (
            <CondorSpinner />
          ) : (
            <div>
              <div style={{ display: 'flex', marginBottom: '16px' }}>
                <div style={{ flexBasis: '40%' }}>
                  <CardKey>Purple Tag</CardKey>
                </div>
                <div style={{ flexBasis: '40%' }}>
                  <CardValue>{purpleTag.tagName}</CardValue>
                </div>
                <div>
                  <IconButton
                    onClick={() => handleDownload(purpleTag, purpleData)}
                    aria-label="download-purple-tag-serial-numbers"
                    title="Download Purple Tag Serial Numbers"
                    disabled={!purpleData?.getDeviceTags?.results?.length}
                  >
                    <Download />
                  </IconButton>
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                <div style={{ flexBasis: '40%' }}>
                  <CardKey>Yellow Tag</CardKey>
                </div>
                <div style={{ flexBasis: '40%' }}>
                  <CardValue>{yellowTag.tagName}</CardValue>
                </div>
                <div>
                  <IconButton
                    onClick={() => handleDownload(yellowTag, yellowData)}
                    aria-label="download-yellow-tag-serial-numbers"
                    title="Download Yellow Tag Serial Numbers"
                    disabled={!yellowData?.getDeviceTags?.results?.length}
                  >
                    <Download />
                  </IconButton>
                </div>
              </div>
            </div>
          )}
        </CardContainer>
      </div>
      <div style={{ flexBasis: '20%' }}></div>
    </div>
  );
};
